import { Link, Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { SmoothScroll } from "./SmoothScroll";
import { waLink } from "@/lib/config";
import { getConsultant, consultantWa } from "@/data/team";
import { WaIcon } from "@/components/ui/WaIcon";

const waKeyFor = (path) => {
  if (path.includes("pinjol")) return "pinjol";
  if (path.includes("kartu-kredit")) return "kartu-kredit";
  if (path.includes("kta")) return "kta";
  return "default";
};

const FloatingWA = () => {
  const { pathname } = useLocation();
  const consultant = pathname.startsWith("/konsultan/") && getConsultant(pathname.split("/")[2]);
  return (
    <a
      href={consultant ? consultantWa(consultant) : waLink(waKeyFor(pathname))}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Konsultasi via WhatsApp"
      className="group fixed bottom-5 right-5 z-40 flex items-center gap-3 rounded-full bg-slateb py-2 pl-2 pr-2 text-white shadow-[0_18px_40px_-16px_rgba(51,78,104,.7)] transition-[padding,background-color] duration-500 hover:bg-accentb sm:bottom-7 sm:right-7 sm:pr-5"
    >
      <span className="relative grid h-11 w-11 place-items-center rounded-full bg-sky-brand text-ink">
        <span className="wa-pulse absolute inset-0 rounded-full bg-sky-brand" />
        <span className="relative"><WaIcon /></span>
      </span>
      <span className="hidden text-[13px] font-semibold sm:block">Tanya via WhatsApp</span>
    </a>
  );
};

export default function Layout() {
  return (
    <>
      <SmoothScroll />
      <div className="bg-slateb text-white" data-testid="announcement-bar">
        <p className="wrap py-2.5 text-center text-[12.5px] font-medium">
          Konsultasikan kondisi finansial Anda bersama tim Mika Solution.{" "}
          <Link to="/kontak#konsultasi" className="font-semibold text-sky-brand underline-offset-4 hover:underline" data-testid="announcement-link">Mulai sekarang →</Link>
        </p>
      </div>
      <Navbar />
      <main id="main">
        <Outlet />
      </main>
      <Footer />
      <FloatingWA />
    </>
  );
}
